import { useState, useContext } from 'react'
import { useTranslation } from 'react-i18next'
import MyPicks from './MyPicks'
import { getLocationAffiliates, getOffersAffiliateTitle, hasPremiumAccess } from '../linemate-react-common/src/util'
import GlobalContext from './GlobalContext'
import BonusCard from './BonusCard';
import "./HomeSidebar.scss"
import { buildSignupOfferSections, getTheme } from '../react-web-utils';
import SmallOfferCard from './SmallOfferCard';
import BasicDialog from './BasicDialog';
import PricingPopup from './PricingPopup';

function SidebarOffersList({ entries, cardType }) {
    const CardComponent = cardType === 'bonus' ? BonusCard : SmallOfferCard;

    return (
        <div className='home-sidebar-offers-list'>
            {entries.map((entry) => (
                <CardComponent key={entry.operator} element={entry} theme={getTheme()} source='home_bonus_section' />
            ))}
        </div>
    )
}

function HomeSidebar({}) {
    const context = useContext(GlobalContext);
    const { t } = useTranslation();

    const locationAffiliates = getLocationAffiliates(
        context.location?.region?.code,
        context.location?.country?.code,
        context.configuration.affiliateOffers,
        [],
        context.userAttributes?.confirmedProviders || [],
        context.userAttributes?.preferredProviders || [],
        [],
        context.configuration.advertising?.location?.home?.featured?.tiers || []
    )

    const affiliateEntries = Object.entries(locationAffiliates.affiliates || {}).map(([operator, offers]) => ({
        operator,
        offers
    }))

    const topOffers = affiliateEntries.slice(0, 3)
    const topOfferOperators = topOffers.map((entry) => entry.operator)

    const offerSections = buildSignupOfferSections(
        locationAffiliates.offersByOperator,
        topOfferOperators,
        t
    )

    const partnerEntries = Object.entries(locationAffiliates.offersByOperator || {})
        .map(([operator, offers]) => ({
            operator,
            offers: (offers || []).filter((offer) => offer?.type === 'PARTNER')
        }))
        .filter(({ offers }) => offers.length > 0)

    const [openPricingModal, setOpenPricingModal] = useState(false)

    return (
        <div className='home-sidebar-container'>
            <BasicDialog 
                open={openPricingModal}
                onOpenChange={(open) => setOpenPricingModal(open)}
                content={<PricingPopup variant='plays' onOpenChange={(open) => setOpenPricingModal(open)} />}
                additionalClassName={"pricing-popup-dialog"}
            />
            <MyPicks/>
            {!hasPremiumAccess(context.userAttributes) &&
                <div className='home-sidebar-offers'>
                    <p className='text-style-label-semibold'>{t('home.sidebar.improveExperience')}</p>
                    <div className="linemate-plus-ad-card" onClick={() => setOpenPricingModal(true)}>
                        <img src={`assets/linemate_plus_${getTheme()}.svg`} />
                        <p className="text-style-label-italic-extrabold linemate-plus-ad-card-text">{t('home.sidebar.getAccess')}</p>
                        <img src={`assets/linemate_plus_ad_${getTheme()}.png`} className="linemate-plus-ad-card-image"/>
                    </div>
                </div>
            }

            {topOffers.length > 0 &&
                <div className='home-sidebar-offers'>
                    <p className='text-style-label-semibold'>{`Top ${getOffersAffiliateTitle(context.location.region.code, context.location.country.code, t)}`}</p>
                    <SidebarOffersList entries={topOffers} cardType='bonus' />
                </div>
            }

            {offerSections.map(({ title, entries }) => (
                <div className='home-sidebar-offers' key={title}>
                    <p className='text-style-label-semibold color-fig-subtle'>{title}</p>
                    <SidebarOffersList entries={entries} cardType='small' />
                </div>
            ))}

            {partnerEntries.length > 0 &&
                <div className='home-sidebar-offers'>
                    <p className='text-style-label-semibold color-fig-subtle'>{t('home.offers.types.PARTNER')}</p>
                    <SidebarOffersList entries={partnerEntries} cardType='small' />
                </div>
            }
        </div>
    )
}

export default HomeSidebar;
